// extracted by mini-css-extract-plugin
export default {"root":"DrawerMenuButton_root__x3pDo","alwaysVisible":"DrawerMenuButton_alwaysVisible__E26+d"};